module.exports = __webpack_public_path__ + "assets/img/15_408_big.fba5dd83.jpg";